'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryGhostButton = require('./components/PrimaryGhostButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryGhostButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/primary-ghost-button/index.js
// module id = 1044
// module chunks = 1